import styled from 'styled-components';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import {
  DynamicAlertIcon,
  AlertStyleEnum,
} from '#/transit-tracker/components/DynamicAlertIcon';
import GTM_HANDLES from '#/shared/gtm-handles';
import { ClearLink } from '#/shared/components/Styled/ClearLink';

export const AlertListBody = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${DESKTOP_MIN_BREAK};
  margin-bottom: 5px;
`;

export const BaseAlertRow = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 15px;
  user-select: none;
`;

export const AlertRow = styled(BaseAlertRow).attrs(props => ({
  $alertTypeStyle: AlertStyleEnum[props.type],
}))`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 15px 30px;
  user-select: none;
  background-color: ${props =>
    props.theme[props.$alertTypeStyle.backgroundColor]};
  color: ${props => props.theme[props.$alertTypeStyle.textColor]};
`;

export const AlertIconRow = styled.div``;

export const AlertIcon = styled(DynamicAlertIcon).attrs(props => ({
  width: 50,
  height: 50,
  type: props.type,
}))`
  margin: 8px;
`;

export const AlertHeader = styled.div`
  font-size: 1.3em;
  line-height: 1.3;
  margin-bottom: 5px;
  text-align: center;
`;

export const AlertBody = styled.div`
  font-size: 1em;
  line-height: 1.3;
  margin-bottom: 5px;
`;

export const AlertMoreLink = styled(ClearLink).attrs(props => ({
  target: '_blank',
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.alertsList.globalMoreLink,
  $alertTypeStyle: AlertStyleEnum[props.type],
}))`
  opacity: ${props => props.theme.inactiveOpacity};
  margin-left: 0.2em;
  color: ${props => props.theme[props.$alertTypeStyle.moreTextColor]};
  &:not(:hover) {
    text-decoration: underline;
  }
  @media (any-hover: hover) {
    &:hover {
      opacity: 1;
      background-color: transparent;
    }
  }
`;
